import { render, staticRenderFns } from "./HQUserDetailDialog.vue?vue&type=template&id=510bc9dc&scoped=true"
import script from "./HQUserDetailDialog.vue?vue&type=script&lang=js"
export * from "./HQUserDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./HQUserDetailDialog.vue?vue&type=style&index=0&id=510bc9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bc9dc",
  null
  
)

export default component.exports